export async function shareJson({ jsonData, filename }: { jsonData: any, filename: string }) {
  const jsonString = JSON.stringify(jsonData);
  const blob = new Blob([jsonString], { type: 'application/json' });

  try {
    const file = new File([blob], filename, { type: 'application/json' });

    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: 'Habits',
        text: 'Save backup data',
      });
    } else {
      throw new Error("Sharing is not available");
    }
  } catch (error) {
    console.log('Error sharing JSON:', error);
    // Fallback for browsers that do not support Web Share API file sharing
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}

